import React from "react"

const NumberedCircle = (props) => {
    return (
        <span style={{ background: props.background, color: props.textColor }} className="numbered-circle">{props.number}</span>
    )
}

export default NumberedCircle